import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from './assets/welcome-page-header.jpg'; // Update if needed

function Welcome() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <img
          src={heroImage}
          alt="TOEFL Vocabulary Booster"
          style={styles.image}
        />

        <h1 style={styles.heading}>Welcome to Vocabulary Booster</h1>
        <p style={styles.subheading}>
          Master academic vocabulary and boost your TOEFL/IELTS score with our step-by-step lessons with smart and personalized review system.
        </p>

        <div style={styles.buttonGroup}>
          <Link to="/signin">
            <button style={styles.buttonPrimary}>Sign In</button>
          </Link>
          <Link to="/signup">
            <button style={styles.buttonSecondary}>Sign Up</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: '#f0f6ff',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  container: {
    maxWidth: '800px',
    textAlign: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    padding: '40px 30px',
  },
  image: {
    width: '100%',
    maxWidth: '600px',
    height: 'auto',
    display: 'block',
    margin: '0 auto 30px',
    borderRadius: '8px',
  },
  heading: {
    fontSize: '2.5rem',
    color: '#003366',
    marginBottom: '10px',
  },
  subheading: {
    fontSize: '1.2rem',
    color: '#555',
    marginBottom: '30px',
    lineHeight: 1.6,
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },
  buttonPrimary: {
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: '8px',
    backgroundColor: '#193bdc',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
  buttonSecondary: {
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: '8px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
};

export default Welcome;
